import {coreApi} from '~/services/core'

export const consignmentSupplyService = {
  getAll: async () => coreApi.get(`supplier-consignment`),
  getById: async (id) => coreApi.get(`supplier-consignment?id=${id}`),
  create: async (data) => coreApi.post(`supplier-consignment`, data),
  update: async (data) => coreApi.put(`supplier-consignment`, data),
}